import React, { FC, ReactNode } from 'react';

import { AuthInfo } from 'types';
import { useAppDispatch } from 'store';
import { confirmPhoneAction, resendSmsAction } from 'store/auth/auth.reducer';
import { CodeConfirmation } from './components/CodeConfirmation/CodeConfirmation';

interface Props {
  type: string;
  confirmToken: string;
  onFinish: (data: AuthInfo) => void;
  onResend: (token: string) => void;
  checkbox?: ReactNode;
  appearance?: 'default' | 'login';
}

export const PhoneConfirmation: FC<Props> = ({ type, confirmToken, onFinish, onResend, checkbox, appearance }) => {
  const dispatch = useAppDispatch();

  const handleCodeSend = async (code: string) => {
    const data = await dispatch(confirmPhoneAction({ token: confirmToken, code, type }));
    onFinish(data);
  };

  const handleSmsResend = async () => {
    const { token } = await dispatch(resendSmsAction({ token: confirmToken, type }));
    onResend(token);
  };

  return <CodeConfirmation onSubmit={handleCodeSend} onSmsResend={handleSmsResend} checkbox={checkbox} appearance={appearance} />;
};
